export const isInteger = (value) => {
  if (typeof value === "number") {
    return Number.isInteger(value);
  } else if (typeof value === "string") {
    const integerRegex = /^-?\d+$/;
    return integerRegex.test(value);
  }
  return false;
};

export const isEndDateAfterStartDate = (startDate, endDate) => {
  const start = new Date(startDate);
  const end = new Date(endDate);

  if (isNaN(start) || isNaN(end)) {
    return false;
  }

  return end > start;
};

export const months = [
  { id: 1, name: "Enero" },
  { id: 2, name: "Febrero" },
  { id: 3, name: "Marzo" },
  { id: 4, name: "Abril" },
  { id: 5, name: "Mayo" },
  { id: 6, name: "Junio" },
  { id: 7, name: "Julio" },
  { id: 8, name: "Agosto" },
  { id: 9, name: "Septiembre" },
  { id: 10, name: "Octubre" },
  { id: 11, name: "Noviembre" },
  { id: 12, name: "Diciembre" },
];
